import React from "react";

import EditIcon from "@mui/icons-material/Edit";
import IconBtnTemplate from "./IconBtnTemplate";

type IconSize = "small" | "inherit" | "medium" | "large";

interface EditIconBtnProps {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  size?: IconSize;
  tip?: string;
}

export default function EditIconBtn({ action, size = "small", tip = "Edit" }: EditIconBtnProps) {
  return (
    <IconBtnTemplate
      type="success"
      action={action}
      icon={<EditIcon fontSize={size} />}
      tip={tip}
    />
  );
}
